import { z } from 'zod'

// POST /api/agent/gateway/sessions/{agentSessionId}/attachments/upload-url の本文
export const createAttachmentUploadUrlBodySchema = z.object({
  // workspace/attachments/ に置くファイルの名前。添付できる拡張子かと、名前の形（パスの区切りや制御文字を含まないか）は storage が確かめる
  filename: z.string().min(1),
  // PUT する本体の大きさ（バイト）。上限を超えていないかは storage が、PUT の本体がこの大きさかは S3 が確かめる
  size: z.number().int().nonnegative(),
})

// POST /api/agent/gateway/sessions/{agentSessionId}/attachments/upload-url の応答。storage の createAttachmentUploadUrl の応答から success を除いたもの
export const createAttachmentUploadUrlResponseSchema = z.object({
  // 画面がファイルの本体を PUT する署名付き URL
  url: z.string(),
  // PUT に付けるヘッダー（content-type）。署名に含めた値なので、画面は変えずに付ける
  headers: z.record(z.string(), z.string()),
  // セッションのディレクトリからの相対パス。指示の attachments に渡す
  path: z.string(),
  // URL の期限（ISO 8601）
  expiresAt: z.string(),
})

export type CreateAttachmentUploadUrlResponse = z.infer<typeof createAttachmentUploadUrlResponseSchema>
